// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__7iFh9","Title":"Header_Title__M1qCC","bannerImage":"Header_bannerImage__LcxZc"};